// Third Party
import * as Yup from 'yup';

export type FormSchema = {
  giftCardNumber: string;
};

export const validationSchema: Yup.Schema<FormSchema> = Yup.object()
  .shape({
    giftCardNumber: Yup.string().required('Gift card number is required'),
  })
  .required();

export const initialValues: FormSchema = {
  giftCardNumber: '',
};
